// Service.js
import * as axiosInstances from "../configs/AxiosInstance";

const { axiosInstance, axiosNewInstance } = axiosInstances;

// 🔹 Add interceptor once for both instances
const addInterceptors = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Clear expired/invalid token
        localStorage.removeItem("access_token");
        localStorage.removeItem("user"); // if you store user info

        // Redirect to login
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};

// Apply interceptors to both instances
addInterceptors(axiosInstance);
addInterceptors(axiosNewInstance);

const getAuthConfig = (config, data) => {
  const token = localStorage.getItem("access_token");
  const { instance, ...restConfig } = config || {};
  const headers = {
    ...restConfig.headers,
    Authorization: token ? `Bearer ${token}` : "",
  };
  
  // Don't set Content-Type for FormData - let browser set it with boundary
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  
  return {
    headers,
    ...restConfig,
  };
};

const getInstance = (config) => config?.instance || axiosInstance;

// GET
export const get = async (endpoint, config = {}) => {
  try {
    const instance = getInstance(config);
    const response = await instance.get(endpoint, getAuthConfig(config, null));
    return response.data;
  } catch (err) {
    console.error("GET request failed:", err);
    throw err;
  }
};

// POST
export const post = async (endpoint, data, config = {}) => {
  try {
    const instance = getInstance(config);
    const response = await instance.post(endpoint, data, getAuthConfig(config, data));
    return { data: response.data, status: response.status };
  } catch (err) {
    console.error("POST request failed:", err);
    throw err;
  }
};

// PUT
export const put = async (endpoint, data, config = {}) => {
  try {
    const instance = getInstance(config);
    const response = await instance.put(endpoint, data, getAuthConfig(config, data));
    return response.data;
  } catch (err) {
    console.error("PUT request failed:", err);
    throw err;
  }
};

// PATCH
export const patch = async (endpoint, data, config = {}) => {
  try {
    const instance = getInstance(config);
    const response = await instance.patch(
      endpoint,
      data,
      getAuthConfig(config, data)
    );
    return response.data;
  } catch (err) {
    console.error("PATCH request failed:", err);
    throw err;
  }
};

// DELETE
export const remove = async (endpoint, config = {}) => {
  try {
    const instance = getInstance(config);
    const response = await instance.delete(endpoint, getAuthConfig(config, null));
    return { data: response.data, status: response.status };
  } catch (err) {
    console.error("DELETE request failed:", err);
    throw err;
  }
};
